import styled from "styled-components";

export const Ulstyled = styled.ul`
display: flex;
overflow: auto;
gap: 1rem;
margin-top: 1.9rem;
margin-bottom: 1rem;
padding-top: 1rem;
margin-right: 1rem;

@media (min-width: 950px) {
   flex-wrap: wrap;
}


`